import Spinner from 'components/shared/app/Spinner';
import { findError } from 'lib/utils/errorUtils';
import Button from 'components/shared/app/Button';
import React, { useEffect, useState } from 'react';
import FacebookService from 'services/providers/FacebookService';
import arrowIcon from 'static/icons/icon_arrow_blue_round.svg';

const SignupFbConnect = (props) => {
    const [loading, setLoading] = useState(true);
    const [connectedUser, setConnectedUser] = useState(undefined);
    const [error, setError] = useState('');


    useEffect(async () => {
        let fbStatus = await FacebookService.getLoginStatus();
        console.log(`fb status`, fbStatus)
        if (fbStatus?.status == 'connected') {
            if (fbStatus.authResponse?.userID) {
                let fbUser = await FacebookService.getProfile(fbStatus.authResponse?.userID);
                if (fbUser) {
                    setConnectedUser(fbUser);
                    console.log(fbUser);
                }
            }
        }
        setLoading(false);
    }, []);

    const connectFacebook = async () => {
        try {
            let fbStatus = await FacebookService.getLoginStatus();

            if (fbStatus.status != 'connected') {
                if (await FacebookService.login()) {
                    fbStatus = await FacebookService.getLoginStatus();
                }
            }

            if (fbStatus?.status == 'connected') {
                let token = fbStatus?.authResponse?.accessToken;
                if (!token) return setError("Error retrieving Facebook access token even though it appears you are logged into Facebook. Please clear your browser cache to start a new session, or contact us for help.")
                await FacebookService.setFacebookAccessToken(token);
                const adAccounts = await FacebookService.getMyAdAccounts(token);
                props.setAccountsData(adAccounts);
                props.setFbToken(token);
                props.setFbUserId(fbStatus.authResponse.userID);
                props.setSignupState(1);
            } else {
                setError("Could not connect to Facebook.");
            }
        } catch (e) {
            let eMsg = findError(e);
            setError(eMsg);
        }
    }

    const logoutFacebook = async () => {
        let r = await FacebookService.logout(true);
        setConnectedUser(undefined);
    }

    return (
        <div className="step signup-fb-connect flex-col">

            {!loading ?
                <div className="center flex-col-center">
                    <div className="font-plain-large margin md">
                        {connectedUser ?
                            <div className="already-connected">
                                You are connected to Facebook as:
                                <div className="connected-user">{connectedUser.name}</div>
                                Click Continue below, or Logout to select a different account:
                            </div> :
                            <span>Login to your Facebook account to get started:</span>
                        }
                    </div>

                    <Button round simple bold filled center color="white" icon={<img src={arrowIcon} />} iconPosition="right" textPosition="center" onClick={async (e) => await connectFacebook()}>
                        {connectedUser ? `Continue as ${connectedUser.name}` : 'Connect to Facebook'}
                    </Button>

                    {connectedUser &&
                        <Button round simple bold center color="white" onClick={async (e) => await logoutFacebook()}>Logout of Facebook</Button>
                    }

                    {error &&
                        <div className="error margin lg ns">
                            <h4 className="title">An error occurred:</h4>
                            {error}
                        </div>
                    }
                </div> :
                <Spinner />
            }

        </div>
    )
}

export default SignupFbConnect;